// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'

import router from './router'
import {
  roleConsts,
  approveConsts,
  stateConsts
} from '@/utils/consts.js'

Vue.use(ElementUI)

Vue.prototype.$store = store
Vue.prototype.$roleConsts = roleConsts
Vue.prototype.$approveConsts = approveConsts
Vue.prototype.$stateConsts = stateConsts

Vue.prototype.$getApproveLabel = function(approveValue) {
  for (let key in approveConsts) {
    if (approveConsts[key].value == approveValue) {
      return approveConsts[key].label
    }
  }
  return ''
}

Vue.prototype.$getRoleLabel = function(roleValue) {
  for (let key in roleConsts) {
    if (roleConsts[key].value == roleValue) {
      return roleConsts[key].label
    }
  }
  return ''
}

Vue.prototype.$getStateLabel = function(info) {
  let now = new Date().valueOf()

  if (now >= new Date(info.game_end_time).valueOf()) {
    return stateConsts.GAME_END.label
  } else if (now >= new Date(info.game_start_time).valueOf()) {
    return stateConsts.GAME_STARTED.label
  } else if (now >= new Date(info.sign_end_time).valueOf()) {
    return stateConsts.SIGN_END.label
  } else if (now >= new Date(info.sign_start_time).valueOf()) {
    return stateConsts.SIGN_STARTED.label
  }
  return stateConsts.PENDING.label
}


Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js